module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_6_Lee.4ea52d9ff04043929a4f2628da962826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_6_Lee.png
// module id = 753
// module chunks = 0